/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listOpticheckTasks = /* GraphQL */ `
  query ListOpticheckTasks(
    $filter: ModelOpticheckTaskFilterInput
    $limit: Int
    $nextToken: Int
  ) {
    listOpticheckTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customer_id
        url
        status
        created
        updated
        check_last
        check_interval_value
        job_last
        check_screenshot
        check_countwords
        check_optimization
      }
      total
      nextToken
    }
  }
`;
export const getOpticheckTask = /* GraphQL */ `
  query GetOpticheckTask($id: Int!) {
    getOpticheckTask(id: $id) {
      id
      customer_id
      url
      status
      created
      updated
      check_last
      check_interval_value
      job_last
      check_screenshot
      check_countwords
      check_optimization
    }
  }
`;
export const listOpticheckOptimizations = /* GraphQL */ `
  query ListOpticheckOptimizations(
    $filter: ModelOpticheckOptimizationFilterInput
    $limit: Int
    $nextToken: Int
  ) {
    listOpticheckOptimizations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        task_id
        text
      }
      total
      nextToken
    }
  }
`;
export const getOpticheckOptimization = /* GraphQL */ `
  query GetOpticheckOptimization($id: Int!, $task_id: Int!) {
    getOpticheckOptimization(id: $id, task_id: $task_id) {
      id
      task_id
      text
    }
  }
`;
export const getAdWordsAccount = /* GraphQL */ `
  query GetAdWordsAccount($id: Int!) {
    getAdWordsAccount(id: $id) {
      id
      client_id
      status
      created
      updated
    }
  }
`;
export const getAdWordsReportRequest = /* GraphQL */ `
  query GetAdWordsReportRequest(
    $id: Int!
    $account_id: Int!
    $filter: ModelAdWordsReportRequestFilterInput
    $sort: ModelAdWordsReportRequestSortInput
    $limit: Int
  ) {
    getAdWordsReportRequest(
      id: $id
      account_id: $account_id
      filter: $filter
      sort: $sort
      limit: $limit
    ) {
      id
      account_id
      start
      end
      status
      created
      updated
      report_data {
        id
        report_id
        KeywordId
        Status
        Criteria
        CampaignId
        CampaignName
        CampaignStatus
        AdGroupId
        AdGroupName
        AccountCurrencyCode
        CpcBid
        Clicks
        Impressions
        Ctr
        AverageCpc
        Cost
        Conversions
        ConversionRate
        CostPerConversion
        SearchImpressionShare
        SearchRankLostImpressionShare
        QualityScore
        SearchPredictedCtr
        PostClickQualityScore
        CreativeQualityScore
        uplift_search_predicted_ctr
        uplift_post_click_quality_score
        uplift_creative_quality_score
        uplift_sum
        predicted_decrease_cpc
        predicted_increase_impressions
        predicted_increase_clicks
        predicted_increase_conversions
      }
    }
  }
`;
export const listAdWordsReportRequests = /* GraphQL */ `
  query ListAdWordsReportRequests(
    $filter: ModelAdWordsReportRequestFilterInput
    $limit: Int
    $nextToken: Int
  ) {
    listAdWordsReportRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        account_id
        start
        end
        status
        created
        updated
        report_data {
          id
          report_id
          KeywordId
          Status
          Criteria
          CampaignId
          CampaignName
          CampaignStatus
          AdGroupId
          AdGroupName
          AccountCurrencyCode
          CpcBid
          Clicks
          Impressions
          Ctr
          AverageCpc
          Cost
          Conversions
          ConversionRate
          CostPerConversion
          SearchImpressionShare
          SearchRankLostImpressionShare
          QualityScore
          SearchPredictedCtr
          PostClickQualityScore
          CreativeQualityScore
          uplift_search_predicted_ctr
          uplift_post_click_quality_score
          uplift_creative_quality_score
          uplift_sum
          predicted_decrease_cpc
          predicted_increase_impressions
          predicted_increase_clicks
          predicted_increase_conversions
        }
      }
      total
      nextToken
    }
  }
`;
export const getAdWordsAccountKpiReport = /* GraphQL */ `
  query GetAdWordsAccountKpiReport($id: Int!) {
    getAdWordsAccountKpiReport(id: $id) {
      report
    }
  }
`;
export const getAdWordsAccountConversionsReport = /* GraphQL */ `
  query GetAdWordsAccountConversionsReport($id: Int!) {
    getAdWordsAccountConversionsReport(id: $id) {
      report
    }
  }
`;
export const listGraphQlApis = /* GraphQL */ `
  query ListGraphQlApis {
    listGraphQLApis
  }
`;
export const getToDo = /* GraphQL */ `
  query GetToDo($id: ID!) {
    getToDo(id: $id) {
      id
      title
      description
      editors
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listToDos = /* GraphQL */ `
  query ListToDos(
    $filter: ModelToDoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listToDos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        editors
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      user
      email
      groups
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user
        email
        groups
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      name
      active
      contracts {
        id
        name
        active
        customerID
        contacts {
          salutation
          firstName
          lastName
          email
        }
        webmasterReportTasks {
          id
          contractID
          active
          url
          webRiskTaskID
          createdAt
          updatedAt
        }
        webRiskTasks {
          id
          contractID
          active
          url
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      contacts {
        salutation
        firstName
        lastName
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        active
        contracts {
          id
          name
          active
          customerID
          createdAt
          updatedAt
        }
        contacts {
          salutation
          firstName
          lastName
          email
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContract = /* GraphQL */ `
  query GetContract($id: ID!) {
    getContract(id: $id) {
      id
      name
      active
      customerID
      contacts {
        salutation
        firstName
        lastName
        email
      }
      webmasterReportTasks {
        id
        contractID
        active
        url
        uptimerobot {
          monitorId
        }
        zenkit {
          listShortId
        }
        webRiskTaskID
        createdAt
        updatedAt
      }
      webRiskTasks {
        id
        contractID
        active
        url
        jobsByDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listContracts = /* GraphQL */ `
  query ListContracts(
    $filter: ModelContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContracts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        active
        customerID
        contacts {
          salutation
          firstName
          lastName
          email
        }
        webmasterReportTasks {
          id
          contractID
          active
          url
          webRiskTaskID
          createdAt
          updatedAt
        }
        webRiskTasks {
          id
          contractID
          active
          url
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWebRiskTask = /* GraphQL */ `
  query GetWebRiskTask($id: ID!) {
    getWebRiskTask(id: $id) {
      id
      contractID
      active
      url
      jobsByDate {
        items {
          id
          webRiskTaskID
          date
          urls
          threats
          infected
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listWebRiskTasks = /* GraphQL */ `
  query ListWebRiskTasks(
    $filter: ModelWebRiskTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebRiskTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        contractID
        active
        url
        jobsByDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWebRiskJob = /* GraphQL */ `
  query GetWebRiskJob($id: ID!) {
    getWebRiskJob(id: $id) {
      id
      webRiskTaskID
      date
      urls
      threats
      infected
      createdAt
      updatedAt
    }
  }
`;
export const listWebRiskJobs = /* GraphQL */ `
  query ListWebRiskJobs(
    $filter: ModelWebRiskJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebRiskJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        webRiskTaskID
        date
        urls
        threats
        infected
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWebmasterReportTask = /* GraphQL */ `
  query GetWebmasterReportTask($id: ID!) {
    getWebmasterReportTask(id: $id) {
      id
      contractID
      active
      url
      uptimerobot {
        monitorId
      }
      zenkit {
        listShortId
      }
      webRiskTaskID
      createdAt
      updatedAt
    }
  }
`;
export const listWebmasterReportTasks = /* GraphQL */ `
  query ListWebmasterReportTasks(
    $filter: ModelWebmasterReportTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebmasterReportTasks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contractID
        active
        url
        uptimerobot {
          monitorId
        }
        zenkit {
          listShortId
        }
        webRiskTaskID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWebmasterReportJob = /* GraphQL */ `
  query GetWebmasterReportJob($id: ID!) {
    getWebmasterReportJob(id: $id) {
      id
      webmasterReportTaskID
      readyForSent
      createdAt
      pdf
      expiresAt
      updatedAt
    }
  }
`;
export const listWebmasterReportJobs = /* GraphQL */ `
  query ListWebmasterReportJobs(
    $filter: ModelWebmasterReportJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebmasterReportJobs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        webmasterReportTaskID
        readyForSent
        createdAt
        pdf
        expiresAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const webRiskTaskByActive = /* GraphQL */ `
  query WebRiskTaskByActive(
    $active: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWebRiskTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    webRiskTaskByActive(
      active: $active
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contractID
        active
        url
        jobsByDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const webmasterReportTaskByActive = /* GraphQL */ `
  query WebmasterReportTaskByActive(
    $active: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWebmasterReportTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    webmasterReportTaskByActive(
      active: $active
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contractID
        active
        url
        uptimerobot {
          monitorId
        }
        zenkit {
          listShortId
        }
        webRiskTaskID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const webmasterReportJobByReadyForSent = /* GraphQL */ `
  query WebmasterReportJobByReadyForSent(
    $readyForSent: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWebmasterReportJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    webmasterReportJobByReadyForSent(
      readyForSent: $readyForSent
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        webmasterReportTaskID
        readyForSent
        createdAt
        pdf
        expiresAt
        updatedAt
      }
      nextToken
    }
  }
`;
